import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalOverlayComponent } from './modal-overlay.component';
@NgModule({
  declarations: [ModalOverlayComponent],
  imports: [CommonModule],
  exports: [ModalOverlayComponent],
})
export class ModalOverlayModule {}
